import { STEPS } from "@/content/landing";
import Reveal from "./Reveal";

export default function HowItWorks() {
  return (
    <section className="landing-section" id="comment">
      <Reveal className="section-intro"><span className="eyebrow">{STEPS.eyebrow}</span><h2>{STEPS.title}</h2></Reveal>
      <ol className="steps">
        {STEPS.items.map((s, i) => (
          <Reveal key={s.n} as="li" delay={i * 0.08} className="step">
            <span className="step-n">{s.n}</span>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </Reveal>
        ))}
      </ol>
    </section>
  );
}
